/* eslint-disable no-shadow */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { showReviewPage } from "../../actions/employerPendingReviewsActions";
import {
  ReviewLineWrapper,
  ReviewLineItem,
  ActionButton,
  MobileInfo,
} from "./styles/pending-reviews-page-styles";

interface RecruiterType {
  name?: string;
}

interface RecruiterUserType {
  fullName?: string;
}

interface JobType {
  id?: string;
  title?: string;
}

export interface IReviewProps {
  showReviewPage: (review) => void;
  review: {
    id?: string;
    createdAt?: string;
    job?: JobType;
    recruiter?: RecruiterType;
    recruiterUser?: RecruiterUserType;
  };
}

export const Review: FunctionComponent<IReviewProps> = ({
  showReviewPage,
  review,
}) => (
  <ReviewLineWrapper>
    <ReviewLineItem flex={4}>
      <strong>{review.job.title}</strong>
      <MobileInfo>
        {review.recruiter.name}
        <br />
        {review.createdAt}
      </MobileInfo>
    </ReviewLineItem>
    <ReviewLineItem flex={3} noMobile>
      {review.recruiter.name}
    </ReviewLineItem>
    <ReviewLineItem flex={3} noMobile>
      {review.createdAt}
    </ReviewLineItem>
    <ReviewLineItem flex={2} justifyContent="flex-end">
      <NavLink
        to={`/${review.job.id}/leave-a-review`}
        onClick={() => showReviewPage(review)}
      >
        <ActionButton>
          <FontAwesomeIcon icon={faPencilAlt} />
          add a review
        </ActionButton>
      </NavLink>
    </ReviewLineItem>
  </ReviewLineWrapper>
);

Review.propTypes = {
  showReviewPage: PropTypes.func.isRequired,
  review: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.string,
    recruiter: PropTypes.shape({
      name: PropTypes.string,
    }),
    job: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    }),
  }),
};

Review.defaultProps = {
  review: null,
};

export default connect(null, { showReviewPage })(Review);
